module.exports = __webpack_public_path__ + "img/ac12.92aacee0.jpg";